
import { LyVariantChangedEventListener } from "./base"

function getVariantStatus(variant, lowStockNum) {
    if (variant.preOrderTime && variant.inventoryQuantity <= 0)
        return 'pre-order'

    if (variant.inventoryQuantity <= 0) return 'no-stock'

    if (variant.inventoryQuantity <= lowStockNum)
        return 'low-stock'

    return 'in-stock'
}

if (!customElements.get('ly-main-product-form-stock-overview')) {
    customElements.define('ly-main-product-form-stock-overview', class extends HTMLElement {

        connectedCallback() {
            const script = this.querySelector('script[type="application/json"][data-stock]')
            this.stockConfig = readJsonFromScript(script)

            this.popper = this.querySelector('ly-popover-v4')

            this.productComponents = [...this.popper.bodyContent.querySelectorAll(['ly-main-product-form-stock-overview-product'])]

            this.popper.addEventListener('visibility_change', this.handleChange)
        }

        disconnectedCallback() {
            this.popper.removeEventListener('visibility_change', this.handleChange)
        }

        handleChange = evt => {
            if (!evt.detail.visible) return

            this.productComponents.forEach(c => {
                c.init(this.stockConfig)
            })
        }
    })
}

if (!customElements.get('ly-main-product-form-stock-overview-current-variant')) {
    customElements.define('ly-main-product-form-stock-overview-current-variant', class extends LyVariantChangedEventListener {

        stockConfig = null
        titleDom = null
        prefixDom = null
        suffixDom = null
        preOrderTimeDom = null

        connectedCallback() {
            super.connectedCallback()

            this.stockConfig = this.parentElement.stockConfig

            this.titleDom = this.querySelector('.ly-main-product-form-stock-overview-current-variant-title')
            const textWrapper = this.querySelector('.ly-main-product-form-stock-overview-current-variant-text')
            this.prefixDom = textWrapper.querySelector('.prefix')
            this.suffixDom = textWrapper.querySelector('.suffix')
            this.preOrderTimeDom = textWrapper.querySelector('ly-format-time')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            const stock = this._variantConfigs[variantId]
            if (!stock) return

            const status = getVariantStatus(stock, this.stockConfig.lowStockNum)
            this.dataset.type = status

            const config = this.stockConfig[status]
            this.titleDom.textContent = config.title + ':'
            this.prefixDom.textContent = config.prefixText
            this.suffixDom.textContent = config.suffixText
            this.preOrderTimeDom.dataset.time = status === 'pre-order' ? stock.preOrderTime : ''
        }
    })
}

if (!customElements.get('ly-main-product-form-stock-overview-fallback-variant')) {
    customElements.define('ly-main-product-form-stock-overview-fallback-variant', class extends LyVariantChangedEventListener {

        connectedCallback() {
            super.connectedCallback()

            this.titleDom = this.querySelector('.ly-main-product-form-stock-overview-fallback-variant-title')
            this.linkDom = this.querySelector('.ly-main-product-form-stock-overview-fallback-variant-link')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            const config = this._variantConfigs[variantId]

            this.classList.toggle('ly-hide', !config)

            if (!config) return
            const { variant_fallback, fallback_variant } = config
            this.titleDom.textContent = variant_fallback.title ?? fallback_variant.title
            this.linkDom.textContent = variant_fallback.link_title
            this.linkDom.href = fallback_variant.url
        }
    })
}

if (!customElements.get('ly-main-product-form-stock-overview-product')) {
    customElements.define('ly-main-product-form-stock-overview-product', class extends HTMLElement {
        #initialized = false
        stockConfig = null

        connectedCallback() {
            this.productConfig = readJsonFromScript(this.querySelector('script[type="application/json"][data-product]'))
        }

        disconnectedCallback() {

        }

        init = (stockConfig) => {
            if (this.#initialized) return

            this.stockConfig = stockConfig

            const { option1, option2, hasOption3 } = this.productConfig

            if (hasOption3) {
                // 3 option → 按 option1 分组
                option1.values.forEach(v => this.createGroupWrapper(v))
            } else if (option2?.values?.length) {
                // 2 option
                this.createGroupWrapper()
            } else {
                // 1 option
                this.createGroupWrapper()
            }

            this.#initialized = true
        }

        createGroupWrapper = (option1Value) => {
            const groupWrapper = document.createElement('ly-main-product-form-stock-overview-popover-group-wrapper')

            groupWrapper.classList.add('ly-main-product-form-stock-overview-popover-group-wrapper')

            groupWrapper._stockConfig = this.stockConfig
            groupWrapper._productConfig = this.productConfig

            groupWrapper.innerHTML = `
                ${this.createGroupWrapperHeader(option1Value)}
                ${this.createGroupWrapperBody(option1Value)}
            `

            this.appendChild(groupWrapper)
        }

        createGroupWrapperHeader = (option1Value) => {
            return `
            <div class="ly-main-product-form-stock-overview-popover-group-wrapper-header">
                <div class="ly-main-product-form-stock-overview-popover-group-wrapper-header-inner">
                    <div class="ly-main-product-form-stock-overview-popover-group-title">
                        ${option1Value ?? this.productConfig.productTitle}
                    </div>
                </div>
            </div>
            `
        }

        createGroupWrapperBody = (option1Value) => {
            return `
            <div class="ly-main-product-form-stock-overview-popover-group-wrapper-body">
                ${this.createTabs(option1Value)}
            </div>
            `
        }

        createTabs = (option1Value) => {
            const { option1, option2 } = this.productConfig

            // 3 option → tabs 用 option2
            if (this.productConfig.hasOption3 && option2?.values?.length) {
                return this.renderTabs(option2.values, option1Value)
            }

            // 2 option → tabs 用 option1
            if (option2?.values?.length && option1?.values?.length) {
                return this.renderTabs(option1.values)
            }

            return ''
        }

        renderTabs = (values, option1Value) => {
            if (values.length <= 1) return ''
            const tabsinner = values.map((value, index) => {
                return `
                <label class="ly-main-product-form-stock-overview-popover-group-tab ${index === 0 ? 'is-selected' : ''}" data-value="${value}" data-parent="${option1Value ?? ''}" data-tab>
                    ${this.renderOptionImage(value)}
                    <span class="ly-main-product-form-stock-overview-popover-group-tab-title">${value}</span>
                </label>
                `}).join('')
            return `
            <div class="ly-main-product-form-stock-overview-popover-group-tabs" data-tab-wrapper>
                ${tabsinner}
            </div>
            `
        }

        renderOptionImage = (optionValue) => {
            const img = this.productConfig.optionImageMappings[optionValue]
            let optionImage = ``
            if (img) {
                const widths = [20, 22, 40, 44, 60]
                const srcset = widths.map(width => `${img}&width=${width} ${width}w`).join(',')
                optionImage = `
                <div class="ly-main-product-form-stock-overview-popover-group-tab-image">
                  <img
                    src="${img}&width=20"
                    srcset="${srcset}"
                    sizes="(max-width: 767px) 20px, 22px"
                    width="22"
                    height="22"
                    loading="lazy"
                    draggable="false"
                  >
                </div>
                `
            }
            return optionImage
        }
    })
}

if (!customElements.get('ly-main-product-form-stock-overview-popover-group-wrapper')) {
    customElements.define('ly-main-product-form-stock-overview-popover-group-wrapper', class extends HTMLElement {

        stockConfig = null
        productConfig = null

        gridsWrapper = null

        #selectedValue = null

        /** 缓存已创建 grids */
        #gridMap = new Map()

        connectedCallback() {
            this.stockConfig = this._stockConfig
            this.productConfig = this._productConfig

            this.bodyWrapper = this.querySelector('.ly-main-product-form-stock-overview-popover-group-wrapper-body')

            this.createGridsWrapper()

            this.addTabEvents()

            this.initDefaultGrid()
        }

        disconnectedCallback() {
            this.tabs?.forEach(tab => {
                tab.removeEventListener('click', this.handleClickTab)
            })
        }

        createGridsWrapper = () => {
            const gridsWrapper = document.createElement('div')
            gridsWrapper.classList.add('ly-main-product-form-stock-overview-popover-group-grids-wrapper')

            this.gridsWrapper = gridsWrapper

            this.bodyWrapper.appendChild(gridsWrapper)
        }

        initDefaultGrid = () => {
            // 有 tabs → 正常逻辑
            if (this.#selectedValue) {
                this.ensureGrid(this.#selectedValue)
                return
            }

            // 没有 tabs → 直接创建一个“全部 variants”的 grid
            const grid = this.createGrid('__ALL__')

            this.#gridMap.set('__ALL__', grid)

            this.gridsWrapper.appendChild(grid)

            grid.classList.add('is-visible')
        }

        ensureGrid = (value) => {
            let grid = this.#gridMap.get(value)

            // 没创建过 → 创建
            if (!grid) {
                grid = this.createGrid(value)
                this.#gridMap.set(value, grid)
                this.gridsWrapper.appendChild(grid)
            }

            // 切换显示
            this.#gridMap.forEach((g, key) => {
                g.classList.toggle('is-visible', key === value)
            })
        }

        createGrid = (value) => {
            const grid = document.createElement('ly-main-product-form-stock-overview-popover-group-grids')

            grid.classList.add('ly-main-product-form-stock-overview-popover-group-grids')
            grid.dataset.value = value.split(',').pop()

            const variants = this.filterVariants(value)

            grid.innerHTML = `<div class="ly-main-product-form-stock-overview-popover-group-grids-inner"></div>`

            grid._variantsConfig = variants
            grid._stockConfig = this.stockConfig
            grid._productConfig = this.productConfig

            // 初始化 grid
            requestAnimationFrame(() => {
                grid.createDom()
            })

            return grid
        }

        // 核心过滤逻辑
        filterVariants = (value) => {
            const { variants, hasOption3 } = this.productConfig

            if (value === '__ALL__') return variants

            if (hasOption3) {
                return variants.filter(v => `${v.option1},${v.option2}` === value)
            }

            return variants.filter(v =>
                v.option1 === value || v.option2 === value
            )
        }

        addTabEvents = () => {
            this.tabWrapper = this.bodyWrapper.querySelector('[data-tab-wrapper]')
            if (!this.tabWrapper) return

            this.tabs = [...this.tabWrapper.querySelectorAll('[data-tab]')]

            this.tabs.forEach(tab => {
                if (tab.classList.contains('is-selected')) {
                    const parent = tab.dataset.parent ? `${tab.dataset.parent},` : ''
                    this.#selectedValue = parent + tab.dataset.value
                }

                tab.addEventListener('click', this.handleClickTab)
            })
        }

        handleClickTab = evt => {
            const target = evt.currentTarget
            const value = target.dataset.value
            const parent = target.dataset.parent ? `${target.dataset.parent},` : ''

            if (this.#selectedValue === value) return

            this.#selectedValue = parent + value

            // tab UI
            this.tabs.forEach(tab => {
                tab.classList.toggle('is-selected', tab === target)
            })

            // 创建 or 切换 grids
            this.ensureGrid(this.#selectedValue)
        }
    })
}

if (!customElements.get('ly-main-product-form-stock-overview-popover-group-grids')) {
    customElements.define('ly-main-product-form-stock-overview-popover-group-grids', class extends HTMLElement {

        #media = window.matchMedia('(min-width: 768px)')

        #sizeMap = null
        #typeMap = null

        #createdMode = null
        #isCreating = false

        #mobileGridItemCount = 6
        #desktopGridItemCount = 9

        connectedCallback() {
            this.variantsConfig = this._variantsConfig
            this.stockConfig = this._stockConfig
            this.productConfig = this._productConfig

            this.domWrapper = this.querySelector('.ly-main-product-form-stock-overview-popover-group-grids-inner')

            this.#media.addEventListener('change', this.handleMediaChange)
        }

        disconnectedCallback() {
            this.#media.removeEventListener('change', this.handleMediaChange)
        }

        /** 创建dom */
        createDom = () => {
            if (!this.variantsConfig) return

            const mode = this.#media.matches ? 'desktop' : 'mobile'

            // 已经渲染过当前模式 → 直接跳过
            if (this.#createdMode === mode) return

            if (this.#isCreating) return
            this.#isCreating = true

            // 初始化 Map（只做一次）
            if (this.productConfig) {
                this.#initMaps()
            }

            // 判断是否走 custom 逻辑
            const isCustomPreOrder = this.hasAttribute('data-custom-pre-order')

            // 清空旧 DOM（关键）
            this.domWrapper.innerHTML = ''

            // 渲染
            this.#render(mode, isCustomPreOrder)

            this.#createdMode = mode
            this.#isCreating = false
        }

        /** 建立映射关系 */
        #initMaps = () => {
            // 没有 productConfig → 不做任何事
            if (!this.productConfig) return

            if (this.#sizeMap && this.#typeMap) return

            this.#sizeMap = new Map()
            this.#typeMap = new Map()

            this.productConfig.pergolaSizeVariantConfigList.forEach(c => {
                c.variantIds.split(',').forEach(id => {
                    this.#sizeMap.set(Number(id), c)
                })
            })

            this.productConfig.v2PergolaSizeTypeConfigList.forEach(c => {
                c.variantIds.split(',').forEach(id => {
                    this.#typeMap.set(Number(id), c.type)
                })
            })
        }

        #renderGridItems(grid, variants, isCustomPreOrder, done) {
            const CHUNK_SIZE = 10
            let index = 0

            const renderChunk = () => {
                const fragment = document.createDocumentFragment()

                for (let i = 0; i < CHUNK_SIZE && index < variants.length; i++, index++) {
                    const variant = variants[index]

                    fragment.appendChild(
                        isCustomPreOrder
                            ? this.#createCustomItem(variant)
                            : this.#createItem(variant)
                    )
                }

                grid.appendChild(fragment)

                if (index < variants.length) {
                    requestAnimationFrame(renderChunk)
                } else {
                    done?.()
                }
            }

            renderChunk()
        }

        /** 渲染 */
        #render = (mode, isCustomPreOrder) => {
            const perPage = isCustomPreOrder
                ? 12
                : (mode === 'desktop'
                    ? this.#desktopGridItemCount
                    : this.#mobileGridItemCount)

            const sourceVariants = isCustomPreOrder
                ? this.variantsConfig.filter(variant => {
                    return !(variant.preOrderTime && variant.inventoryQuantity <= 0)
                })
                : this.variantsConfig

            const total = sourceVariants.length
            const pageCount = Math.ceil(total / perPage)

            const scrollerWrapper = document.createElement('ly-full-scroll-carousel')
            const scroller = document.createElement('div')

            scroller.classList.add(
                'ly-main-product-form-stock-overview-popover-group-grids-inner-scroller',
                'ly-hide-scrollbar'
            )
            scroller.setAttribute('data-scroller', '')

            if (pageCount > 1) {
                scroller.style.setProperty('--rows', isCustomPreOrder ? 4 : 3)
            }

            scrollerWrapper.appendChild(scroller)

            // ❗还没 append 到 DOM

            let pageIndex = 0

            const renderPage = () => {
                if (pageIndex >= pageCount) {
                    // 所有 page 渲染完成 → 再加 indicators
                    if (pageCount > 1) {
                        this.#createIndicators(scrollerWrapper, pageCount)
                    }

                    // ✅ 最后一步：一次性挂载（保证完整 DOM）
                    this.domWrapper.appendChild(scrollerWrapper)

                    return
                }

                const start = pageIndex * perPage
                const end = start + perPage

                const variants = sourceVariants.slice(start, end)

                const grid = document.createElement('div')
                grid.className = isCustomPreOrder
                    ? 'ly-main-product-form-stock-overview-popover-group-grids-inner-custom-pre-order-grid'
                    : 'ly-main-product-form-stock-overview-popover-group-grid'

                grid.setAttribute('data-scroller-item', '')

                scroller.appendChild(grid)

                this.#renderGridItems(grid, variants, isCustomPreOrder, () => {
                    pageIndex++
                    requestAnimationFrame(renderPage)
                })
            }

            renderPage()
        }

        #createItem(variant) {
            const item = document.createElement('div')
            item.className = 'ly-main-product-form-stock-overview-popover-group-grid-item'

            const status = getVariantStatus(variant, this.stockConfig.lowStockNum)
            item.classList.add(status)

            // O(1) 查询
            const sizeConfig = this.#sizeMap?.get(variant.id)
            const type = this.#typeMap?.get(variant.id)

            item.innerHTML = `
            <div class="ly-main-product-form-stock-overview-popover-group-grid-item-info">
              <div class="ly-main-product-form-stock-overview-popover-group-grid-item-header
              ${sizeConfig ? 'is-pergola' : ''}">
                <div class="ly-main-product-form-stock-overview-popover-group-grid-item-header-meta">
                  <div class="ly-main-product-form-stock-overview-popover-group-grid-item-header-meta-title">
                    ${sizeConfig?.showTitle ?? variant.option3 ?? variant.option2 ?? variant.option1}
                  </div>
                  ${type ? `<div class="ly-main-product-form-stock-overview-popover-group-grid-item-header-meta-size-type">${type}</div>` : ''}
                </div>
                <div class="ly-main-product-form-stock-overview-popover-group-grid-item-header-meta-components-title">
                  ${sizeConfig?.componentsTitle ?? ''}
                </div>
              </div>
              <div class="ly-main-product-form-stock-overview-popover-group-grid-item-text">
                <span>${this.stockConfig[status].prefixText}</span>
                <span>${this.stockConfig[status].suffixText}</span>
                ${variant.preOrderTime && variant.inventoryQuantity <= 0 ? `<ly-format-time data-time="${variant.preOrderTime}"></ly-format-time>` : ''}
              </div>
            </div>
            <div class="ly-main-product-form-stock-overview-popover-group-grid-item-status">
              ${this.stockConfig[status].title}
            </div>
            `

            return item
        }

        #createCustomItem(variant) {
            const item = document.createElement('div')
            item.className = 'ly-main-product-form-stock-overview-popover-group-grids-inner-custom-pre-order-grid-item'

            const status = getVariantStatus(variant, this.stockConfig.lowStockNum)
            item.classList.add(status)

            const sizeConfig = this.#sizeMap?.get(variant.id)

            item.innerHTML = `
            <div class="ly-main-product-form-stock-overview-popover-group-grids-inner-custom-pre-order-grid-item-title">
                ${sizeConfig?.showTitle ?? variant.option3 ?? variant.option2 ?? variant.option1}
            </div>

            <div class="ly-main-product-form-stock-overview-popover-group-grids-inner-custom-pre-order-grid-item-status">
                ${this.stockConfig[status].title}
            </div>
            `

            return item
        }

        #createIndicators(wrapper, pageCount) {
            const indicatorsWrapper = document.createElement('div')
            indicatorsWrapper.className = 'ly-main-product-form-stock-overview-popover-group-grids-inner-indicators'

            const indicators = document.createElement('div')
            indicators.className = 'ly-indicators-items'

            for (let i = 0; i < pageCount; i++) {
                const dot = document.createElement('span')
                dot.className = 'ly-indicators-item'
                dot.setAttribute('data-carousel-indicator', '')

                if (i === 0) dot.classList.add('is-active')

                indicators.appendChild(dot)
            }

            indicatorsWrapper.appendChild(indicators)
            wrapper.appendChild(indicatorsWrapper)
        }

        handleMediaChange = () => {
            this.#createdMode = null
            this.createDom(this.stockConfig, this.productConfig)
        }
    })
}